const PHRASE = {
  entered: 'entered',
  left: 'left'
};
const GAP_SECONDS = 0.15;

const nextStartAt = new WeakMap();

export function hallAnnouncementPhrase(username, action) {
  const verb = PHRASE[action];
  const name = String(username || '').replace(/[\r\n\t]+/g, ' ').replace(/\s+/g, ' ').trim();
  if (!verb || !name || /^guest$/i.test(name)) return '';
  return `${name.slice(0, 32)} ${verb}`;
}

function decodeAudio(ctx, data) {
  return new Promise((resolve, reject) => {
    const result = ctx.decodeAudioData(data, resolve, reject);
    if (result && typeof result.then === 'function') result.then(resolve, reject);
  });
}

function playBuffer(ctx, buffer) {
  const source = ctx.createBufferSource();
  source.buffer = buffer;
  source.connect(ctx.destination);
  const startAt = Math.max(ctx.currentTime, nextStartAt.get(ctx) || 0);
  source.start(startAt);
  nextStartAt.set(ctx, startAt + buffer.duration + GAP_SECONDS);
}

/**
 * Plays an announcement through the hall's voice AudioContext. Callers only pass
 * a context while voice is on: an active mic lets iPhone Safari play Web Audio
 * without a tap, and Web Audio mixes with the TV where system speech pauses it.
 */
export async function playHallAnnouncement(payload, ctx) {
  const username = payload?.username;
  const action = payload?.action;
  const key = typeof payload?.audioKey === 'string' ? payload.audioKey : '';
  if (!ctx || !key || !hallAnnouncementPhrase(username, action)) return false;
  try {
    const res = await fetch(`/api/hall-announce-audio/${encodeURIComponent(key)}`);
    if (!res.ok) throw new Error(`announcement audio ${res.status}`);
    const buffer = await decodeAudio(ctx, await res.arrayBuffer());
    if (ctx.state === 'closed') return false;
    if (ctx.state !== 'running') {
      const resumed = ctx.resume();
      if (resumed && typeof resumed.catch === 'function') resumed.catch(() => {});
    }
    playBuffer(ctx, buffer);
    return true;
  } catch (err) {
    console.warn('[hall-announce] could not play announcement:', err.message);
    return false;
  }
}
